import clsx from 'clsx';
import { t } from '@lingui/core/macro';
import { BookmarkSelectionContextValue } from '../../../contexts/BookmarkSelectionContext';

interface BookmarkCheckboxProps {
  bookmarkId: string;
  bookmarkTitle: string;
  bookmarkUrl: string;
  isSelected: boolean;
  isBatchMode: boolean;
  selectionContext: BookmarkSelectionContextValue;
  className?: string;
}

function BookmarkCheckbox({
  bookmarkId,
  bookmarkTitle,
  bookmarkUrl,
  isSelected,
  isBatchMode,
  selectionContext,
  className,
}: BookmarkCheckboxProps) {
  const handleChange = () => {
    selectionContext.toggleBookmark(bookmarkId);
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault(); // Prevent the label from handling the click
    handleChange();
  };

  const label = bookmarkTitle || bookmarkUrl;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={clsx('bookmark-checkbox', className)}
      tabIndex={isBatchMode ? 0 : -1}
      role="checkbox"
      aria-checked={isSelected}
      aria-label={t`Select ${label}`}
    >
      <span className="checkbox-button">
        {isSelected && (
          <svg
            width="7"
            height="6"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 4.31034L3.69231 7L8 1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </button>
  );
}

export default BookmarkCheckbox;
